export default "__VITE_ASSET__Dd_$8rdQ__"